import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams, Events } from "ionic-angular";
import { Store } from "@ngrx/store";
import { Http, Response } from "@angular/http";
//import { MarketContract } from '../../app/app.contract';
import { ContractsService } from "../../app/app.contract.service";
import { AppState } from "../../app/app.reducer";
import { AppUtilities } from "../../app/app.utilities";
import { ConfirmationPage } from "../confirmation/confirmation";
import { NodeService } from "../../services/node.service";
import { Token, Transaction, Wallet } from "../../app/app.models";
import { TokensFetchAction } from "../../app/app.actions";
import { ConfigService } from "../../services/config.service";
import { CommissionsPage } from "../commissions/commissions";

import { HomePage } from "../home/home";
import { WatacardLoadingSerivce } from "../../services/watacard.loading.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "page-tokensell",
  templateUrl: "tokensell.html"
})
export class TokensellPage {
  public formData: FormGroup;
  public token$: Token;
  public wallet$: Wallet;
  private dollarAmount: any;
  private bitcoinValue: number;
  public holderText: string;
  check: boolean;

  constructor(
    private contractService: ContractsService,
    public formBuilder: FormBuilder,
    public navCtrl: NavController,
    public navParams: NavParams,
    public nodeService: NodeService,
    public store: Store<AppState>,
    public utilities: AppUtilities,
    private loadingService: WatacardLoadingSerivce,
    private http: Http,
    private configService: ConfigService,
    private translateService: TranslateService,
    private events: Events
  ) {
    this.token$ = navParams.data;
    this.check = false;

    this.store.select("wallet").subscribe((wallet: Wallet) => {
      this.wallet$ = wallet;
      //this.getBitcoinValue();
    });

    this.formData = this.formBuilder.group({
      price: ["", Validators.required],
      check: [false, [Validators.required]]
    });
    var idioma = this.configService.getIdiom();
    if (idioma == "en") this.holderText = "Enter the price here";
    if (idioma == "es") this.holderText = "Introduce el precio aquí";
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad TokensellPage");
  }

  getBitcoinValue() {
    this.http
      .get("https://api.coinbase.com/v2/prices/spot?currency=USD")
      .subscribe((res: Response) => {
        if (res) {
          this.bitcoinValue = parseFloat(res.json().data.amount);
        }
      });
  }

  cancel() {
    this.navCtrl.pop();
  }

  onSubmit(formData: FormGroup) {
    if (formData.value.check) {
      var price1 = formData.value.price.split(".")[1];
      var price2 = formData.value.price.split(",")[1];
      if (price1 || price2) {
        this.messageAlertDeciamls();
      } else {
        var tx = this.loadingService.getTempTx();
        if (tx) {
          this.nodeService
            .getTransactionTemp(tx)
            .then((result: any) => {
              if (result.blockNumber) {
                this.sendNewTransaction(formData);
              } else {
                this.messageAlert();
              }
            })
            .catch(err => {
              this.messageAlert();
            });
        } else {
          this.sendNewTransaction(formData);
        }
      }
    } else {
      var idioma = this.configService.getIdiom();
      if (idioma == "en")
        this.utilities.alert("You must accept the commissions");
      if (idioma == "es") this.utilities.alert("Debes aceptar las comisiones");
    }
  }

  sendNewTransaction(formData: any) {
    //translate
    var put_sale_ok = this.translateService.instant("tokensell.put_sale_ok");
    var operation_not_perform = this.translateService.instant(
      "tokensell.operation_not_perform"
    );
    var price_wata = this.translateService.instant("tokensell.price_wata");
    var fields_format = this.translateService.instant(
      "tokensell.fields_format"
    );

    if (formData.valid) {
      if (parseFloat(formData.value.price) > 0.00009) {
        let options = this.contractService.MarketContract.setAssetPrice.toPayload(
          [this.token$.assetId, parseFloat(formData.value.price) * 1000000]
        );

        let transaction: Transaction = {
          from: this.wallet$.address,
          to: this.contractService.MarketContract.address,
          data: options.data
        };
        var N = 2;
        this.nodeService
          .sendTransaction(transaction, true)
          .then((tx: any) => {
            if (tx != "error") {
              this.loadingService.setTemp(tx, this.token$, this.token$.assetId);
              this.utilities.alert(put_sale_ok);
              this.events.publish("sellWatacard", true);
              this.navCtrl.popTo(
                this.navCtrl.getByIndex(this.navCtrl.length() - (N + 1))
              );
              //this.navCtrl.setRoot(HomePage);
            } else {
              this.utilities.alert(operation_not_perform);
              this.events.publish("sellWatacard", true);
              this.navCtrl.popTo(
                this.navCtrl.getByIndex(this.navCtrl.length() - (N + 1))
              );
              //this.navCtrl.setRoot(HomePage);
            }
          })
          .catch(error => {
            var message = "Error: replacement transaction underpriced";

            this.utilities.alert(error);
            this.events.publish("sellWatacard", false);
            this.navCtrl.popTo(
              this.navCtrl.getByIndex(this.navCtrl.length() - (N + 1))
            );
            //this.navCtrl.setRoot(HomePage);
          });
      } else {
        this.utilities.alert(price_wata);
      }
    } else {
      this.utilities.alert(fields_format);
    }
  }

  onInputTime($event) {
    let val = $event.target.value;
    this.dollarAmount = parseFloat(val) * this.bitcoinValue;
  }

  messageAlert() {
    var message_alert = this.translateService.instant("token.message_alert");
    this.utilities.alert(message_alert);
  }

  messageAlertDeciamls() {
    var price_integer = this.translateService.instant(
      "tokensell.price_integer"
    );
    this.utilities.alert(price_integer);
  }

  goCommissions() {
    this.navCtrl.push(CommissionsPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tokensell/tokensell.ts